import React from 'react';
import { useAppSelector } from 'store/hooks';

import { USER_ROLES } from 'constants/common';

import { userSelector } from 'store/auth/selectors';

import { useDailyChallengeCourse } from 'hooks/useDailyChallengeCourse';

import { MarketingSettings } from 'pages/CoursePage/components/MarketingSettings';

import DailyChallengePage from './DailyChallengePage';

const DailyChallengePageContainer = () => {
  const {
    loading,
    saveLoading,
    autoSaveLoading,
    readOnly,
    marketingSettingsOpen,
    data: dailyChallenge,
    lastActionAt,
    closeMarketingSettings,
    onAutoSaveSubmit,
    onSaveClick,
    onPreviewClick,
    onStatusContextItemClick,
    onMoreContextItemClick,
  } = useDailyChallengeCourse();

  const user = useAppSelector(userSelector);
  const isRootAdmin = user.role === USER_ROLES.ROOT_ADMIN;

  return (
    <>
      <DailyChallengePage
        loading={loading}
        isRootAdmin={isRootAdmin}
        saveLoading={saveLoading}
        autoSaveLoading={autoSaveLoading}
        dailyChallenge={dailyChallenge}
        lastActionAt={lastActionAt}
        readOnly={readOnly}
        onAutoSaveSubmit={onAutoSaveSubmit}
        onSaveClick={onSaveClick}
        onPreviewClick={onPreviewClick}
        onStatusContextItemClick={onStatusContextItemClick}
        onMoreContextItemClick={onMoreContextItemClick}
      />
      <MarketingSettings
        open={marketingSettingsOpen}
        onClose={closeMarketingSettings}
      />
    </>
  );
};

export default React.memo(DailyChallengePageContainer) as any;
